import React, { useState, useContext } from "react";
import { Grid, Button, Box } from "@mui/material";
import CustomLabel from "../common/customLabel";
import CardMontoDisponible from "./cardMontoDisponible";
import UseIconHooks from "../../hooks/useIconHooks";
import colors from "../../../config/colors";
import { labelInfoGeneralDatoAfiliacion } from "../../global/styles";
import { createIdTag } from "../../utils/helpers";
import { ConfigurationContext } from "../../context/configurationContext";
import CustomConfirmModal from "../common/customConfirmModal";
import * as apiService from "../../../api";

const BalanceSection = ({
  infoGeneralActual,
  datos,
  esDispositivoSeguro: esDispositivoSeguroProp = false,
  ButtonComponent = null,
  onOpenConfirmModal,
  onDispositivoSeguroChange, // Callback para notificar cambios al padre
  title = "Balance de montos disponibles",
  customStyles = {},
  mostrarPlan = false,
  esDatosAfiliacionBalances = false
}) => {
  const {
    esDispositivoActualSeguro,
    idDispositivo,
    correoTitular,
    contratoTitular,
  } = useContext(ConfigurationContext);

  const [esDispositivoSeguro, setEsDispositivoSeguro] = useState(
    esDispositivoSeguroProp || esDispositivoActualSeguro()
  );
  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  // Función para actualizar el estado y notificar al padre
  const updateEsDispositivoSeguro = (newValue) => {
    setEsDispositivoSeguro(newValue);
    if (onDispositivoSeguroChange) {
      onDispositivoSeguroChange(newValue);
    }
  };

  const handleVerDisponible = (RegistrarDispositivo) => {
    apiService.autentificacion
      .SolicitarOtpMedicamentos(
        datos.datosPersonales.codigoAfiliado,
        correoTitular ? correoTitular : datos.datosContacto.correoElectronico,
        idDispositivo,
        RegistrarDispositivo
      )
      .then((response) => {
        setOpenConfirmModal(false);
        window.open(
          response.data.result.url,
          "popupWindow",
          "width=700,height=700,top=100,left=100,resizable=no,scrollbars=no,toolbar=no,menubar=no,location=no,status=no"
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handlerOpenConfirmModal = async () => {
    // if (contratoTitular !== datos.datosPersonales.codigoAfiliado) {
    //   handleVerDisponible(false);
    //   return;
    // }

    const responseDispositivos =
      await apiService.autentificacion.getDispositivosSegurosDeAfiliado(
        datos.datosPersonales.codigoAfiliado
      );
    const { dispositivosSeguros } = responseDispositivos.data.result;

    if (
      dispositivosSeguros.find(
        (d) => d.identificadorDispositivo === idDispositivo
      )
    ) {
      updateEsDispositivoSeguro(true);
      return;
    }

    setOpenConfirmModal(true);
  };

  const handleMostrarTituloCardMontoDisponible = (descripcion, plan) => {
    if (plan) {
      return plan.tipoPlan;
    }
    if (mostrarPlan) {
      return infoGeneralActual.tipoPlan;
    }

    if (descripcion) {
      return descripcion
    }
    return "Alto Costo"
  }

  // Estilos mejorados para el botón principal
  const buttonStyles = {
    default: {
      padding: "16px 24px",
      borderRadius: "12px",
      fontSize: "16px",
      fontWeight: "600",
      textTransform: "none",
      boxShadow: "0 4px 12px rgba(76, 175, 80, 0.3)",
      background: `linear-gradient(135deg, ${colors.primary} 0%, #45a049 100%)`,
      color: "white",
      border: "none",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      position: "relative",
      overflow: "hidden",
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "0 6px 20px rgba(76, 175, 80, 0.4)",
        background: `linear-gradient(135deg, #45a049 0%, ${colors.primary} 100%)`,
      },
      "&:active": {
        transform: "translateY(0)",
      },
      ...customStyles.button,
    },
    container: {
      backgroundColor: "#f8fffe",
      borderRadius: "16px",
      border: `2px solid ${colors.primary}20`,
      padding: "24px",
      marginBottom: "16px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      ...customStyles.container,
    },
  };

  if (!infoGeneralActual?.balances || infoGeneralActual.balances.length === 0) {
    return null;
  }

  return (
    <>
      <Grid item xs={12} marginTop={3}>
        <CustomLabel
          style={{
            ...labelInfoGeneralDatoAfiliacion,
            ...customStyles.title,
          }}
        >
          {title}
        </CustomLabel>
      </Grid>

      {!esDispositivoSeguro ? (
        <Grid item xs={12}>
          <Box style={buttonStyles.container}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              gap={2}
            >
              <CustomLabel
                style={{
                  fontSize: "18px",
                  fontWeight: "500",
                  color: colors.primary,
                  textAlign: "center",
                  marginBottom: "8px",
                }}
              >
                Consulta el balance disponible de tus medicamentos
              </CustomLabel>
              <Button
                id="btn-ver-disponible"
                variant="contained"
                startIcon={UseIconHooks("medication", {
                  fontSize: "large",
                  style: { marginRight: "8px" },
                })}
                onClick={handlerOpenConfirmModal}
                sx={buttonStyles.default}
                style={{
                  minWidth: "280px",
                  ...buttonStyles.default,
                }}
              >
                Ver disponible de medicamentos
              </Button>
              <CustomLabel
                style={{
                  fontSize: "14px",
                  color: colors.gray,
                  textAlign: "center",
                  fontStyle: "italic",
                }}
              >
                Accede de forma segura al balance de tus medicamentos
              </CustomLabel>
            </Box>
          </Box>
        </Grid>
      ) : (
        <Grid container spacing={2}>
          {!esDatosAfiliacionBalances ? 
          infoGeneralActual.balances.map((item) => (
            <Grid item md={6} xs={12} key={item.descripcion}>
              <CardMontoDisponible
                id={createIdTag("card", item.descripcion)}
                idTipoBalance={item.idTipoBalance}
                title={handleMostrarTituloCardMontoDisponible(item.descripcion,null)}
                minHeightBarra={60}
                maximoBarra={item.montoTope}
                actualBarra={item.disponible}
                ButtonComponent={ButtonComponent ? ButtonComponent(item) : null}
                fechaRenovacion={item.fechaRenovacion}
                mostrarPlan={mostrarPlan}
              />
            </Grid>
          )) : datos.datosAfiliacion.map(info => (
            info.balances.map((item) => (
            <Grid item md={6} xs={12} key={item.descripcion}>
              <CardMontoDisponible
                id={createIdTag("card", item.descripcion)}
                idTipoBalance={item.idTipoBalance}
                title={handleMostrarTituloCardMontoDisponible(item.descripcion,info)}
                minHeightBarra={60}
                maximoBarra={item.montoTope}
                actualBarra={item.disponible}
                ButtonComponent={ButtonComponent ? ButtonComponent(item) : null}
                fechaRenovacion={item.fechaRenovacion}
                mostrarPlan={mostrarPlan}
              />
            </Grid>
          ))
          ))}
          
        </Grid>
      )}

      <CustomConfirmModal
        open={openConfirmModal}
        closeHandler={() => setOpenConfirmModal(false)}
        mensaje={"¿Deseas agregar este dispositivo como seguro?"}
        segundoMensaje={
          "Al hacerlo, podrás visualizar el disponible rápidamente en tus próximas consultas"
        }
        yesHandler={() => handleVerDisponible(true)}
        noHandler={() => handleVerDisponible(false)}
        labelYes="Si"
        labelNo="No"
      />
    </>
  );
};

export default BalanceSection;